<div class="w-full bg-white rounded-lg shadow dark:border dark:bg-zinc-900 dark:border-zinc-800">
  <div class="p-6 space-y-4 md:space-y-6 sm:p-8">
    <h1 class="text-xl font-semibold leading-tight tracking-tight text-zinc-900 md:text-2xl dark:text-white">
      Recuperar senha
    </h1>
    <form class="space-y-8 md:space-y-8 mt-12" [formGroup]="form" (submit)="submit(form)">
      <div class="w-full">
        <p-floatlabel>
          <input
            pInputText
            id="email"
            formControlName="email"
            fluid
            autocomplete="off"
            [invalid]="email.dirty && email.errors"
          />
          <label for="email">Seu email</label>
        </p-floatlabel>
        @if (email.dirty && email.hasError('required')) {
          <p-message severity="error" variant="simple" size="small">Email é obrigatório</p-message>
        } @else if (email.dirty && email.hasError('email')) {
          <p-message severity="error" variant="simple" size="small">Por favor insira um email válido</p-message>
        }
      </div>
      <p-button
        type="submit"
        class="font-medium"
        fluid
        [loading]="loading()"
      >
        Recuperar senha
      </p-button>
    </form>
  </div>
</div>
